import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../../Icon';
import styles from './FaqItem.css';

const cx = classnames.bind(styles);

function FaqItem({ question, answer, isOpenByDefault }) {
    const [isOpen, setIsOpen] = useState(isOpenByDefault);

    const toggleOpen = () => {
        setIsOpen(prevIsOpen => !prevIsOpen);
    };

    return (
        <li className={styles.root}>
            <button
                type='button'
                className={styles.header}
                aria-expanded={isOpen}
                onClick={toggleOpen}
            >
                <span className={styles.question}>{question}</span>
                <Icon
                    name='chevronDown'
                    className={cx('icon', { iconOpen: isOpen })}
                />
            </button>
            <div className={cx('answerWrapper', { open: isOpen })}>
                <p className={styles.answer}>{answer}</p>
            </div>
        </li>
    );
}

FaqItem.propTypes = {
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
    isOpenByDefault: PropTypes.bool
};

FaqItem.defaultProps = {
    isOpenByDefault: false
};

export {
    FaqItem
};
